<template>
  <div style="display: flex; justify-content: center;">
    <div class="register-container">
      <form style="margin: 1em 0 2m 0;">
        
        <div style="margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">Email adress*</p>
          <input class="input-add" style="width: 90%;" placeholder="Enter your email" ref="email" v-model="email" @click="select($refs.email, email)" type="text" @keyup.enter="select($refs.password, password)" maxlength="1000">
        </div> 

        <div style="margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">Password*</p>
          <input class="input-add" style="width: 90%;" placeholder="Create a password" ref="password" v-model="password" @click="select($refs.password, password)" type="password" @keyup.enter="register" maxlength="1000">
        </div>

        <button type="button" class="primary-button" style="width: 100%; margin-left: 0px;" @click="register">Create account</button>

        <div class="separator-container">
          <div class="separator-text"><span>or</span></div>
        </div>

        <button type="button" @click="loginWithTwitter" class="primary-button twitter-button"><i class="fab fa-twitter twitter-icon"></i>Sign up with Twitter</button>

        <div style="text-align: center; margin-top: 25px;">
          <p>Already have an account? <router-link to="/login">Log in</router-link></p>
        </div>

        <div style="text-align: center; margin-top: 25px; font-size: 12px;">
          <p>By signing up you agree to our <router-link to="/privacy">terms and privacy policy.</router-link></p>
        </div>

        <p class="p-error" v-if="errors.showMissingError">⚠️ Missing fields from above</p>
        <p class="p-error" v-if="errors.showEmailBadFormat">⚠️ Email format required, example: john@domain.com</p>
        <p class="p-error" v-if="errors.showLoginError">⚠️ Incorrect Login, try again</p>
        <p class="p-error" v-if="errors.showLoginTwitterError">⚠️ Twitter login error, contact developers</p>
      </form>
    </div>
  </div>
</template>

<script>
import * as validator from 'email-validator'
import firebase from '@/firebase'

export default {
  name: 'Register',

  data() {
    return {
      errors: {
        showEmailBadFormat: false,
        showMissingError: false,
        showLoginError: false,
        showLoginTwitterError: false,
      },
      email: '',
      password: '',
    }
  },

  mounted() {
    firebase.auth.getRedirectResult()
      .then(x => {
        if(x.user != null){
          this.$router.push({ path: "/" })
        }
      })
      .catch(x => console.error(x))
  },

  methods: {
    async loginWithTwitter() {
      const provider = new firebase.firebase.auth.TwitterAuthProvider()
      
      try {
        await firebase.loginWithProvider(provider)
        this.loginSuccess('twitter')
      } catch(error){
        console.error('Twitter login error', error)
        this.errors.showLoginTwitterError = true
      }
    },

    loginSuccess(method) {
      firebase.analytics.logEvent('login', { method })
      this.$router.push({ path: '/' })
    },

    select(ref, model){
      ref.focus()
      ref.setSelectionRange(0, model.length)
    },

    register() {
      this.errors.showEmailBadFormat = false
      this.errors.showMissingError = false
      this.errors.showLoginError = false
      this.errors.showLoginTwitterError = false

      if(!validator.validate(this.email)){
        this.errors.showEmailBadFormat = true
        this.select(this.$refs.email, this.email)
        this.password = ''
      }

      if(this.email == null || this.email == '') {
        this.errors.showMissingError = true
        this.select(this.$refs.email, this.email)
        this.password = ''
      }

      if(this.password == null || this.password == '') {
        this.errors.showMissingError = true
        this.select(this.$refs.password, this.password)
        this.password = ''
      }

      if(this.errors.showEmailBadFormat || this.errors.showMissingError){
        return
      }

      firebase.auth
        .createUserWithEmailAndPassword(this.email, this.password)
          .then(() => {
            firebase.analytics.logEvent('sign_up', { method: 'emailAndPassword' })
            this.$router.push({ path: '/' })
          })
          .catch(() => {
            this.errors.showLoginError = true
            this.select(this.$refs.email, this.email)
            this.password = ''
          })
    },
  },
}
</script>

<style scoped>
.p-error {
  color: red;
}
</style>
